import { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconLock, IconEye, IconEyeOff, IconMailForward, IconArrowLeft } from '@tabler/icons-react';
import PageTitle from '../components/ui/PageTitle';
import { signIn, sendPasswordReset } from '../lib/auth';
import './AdminLogin.css';

// Shared frame for the admin sign-in and password-reset screens.
export function AdminAuthCard(props) {
  return (
    <div className="al-page">
      <PageTitle title={props.pageTitle || 'Admin sign in'} />
      <div className="al-card">
        <div className="al-brand">Andre <span>M</span> Leather</div>
        <div className="al-icon">{props.icon || <IconLock size={22} />}</div>
        <h1 className="al-heading">{props.heading}</h1>
        {props.intro && <p className="al-intro">{props.intro}</p>}
        {props.children}
      </div>
      <Link to="/" className="al-back-site">Back to the shop</Link>
    </div>
  );
}

export function AuthMessage(props) {
  if (!props.text) return null;
  return (
    <div className={'al-msg al-msg--' + (props.kind || 'error')} role={props.kind === 'ok' ? 'status' : 'alert'}>
      {props.text}
    </div>
  );
}

export default function AdminLogin() {
  var _mode = useState('signin'); // 'signin' | 'forgot' | 'sent'
  var mode = _mode[0];
  var setMode = _mode[1];
  var _email = useState('');
  var email = _email[0];
  var setEmail = _email[1];
  var _password = useState('');
  var password = _password[0];
  var setPassword = _password[1];
  var _show = useState(false);
  var showPassword = _show[0];
  var setShowPassword = _show[1];
  var _busy = useState(false);
  var busy = _busy[0];
  var setBusy = _busy[1];
  var _error = useState(null);
  var error = _error[0];
  var setError = _error[1];

  function switchMode(next) {
    setError(null);
    setMode(next);
  }

  async function handleSignIn(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    var res = await signIn(email, password);
    setBusy(false);
    if (res.error) {
      setError(res.error);
      setPassword('');
    }
    // On success the admin panel replaces this screen by itself.
  }

  async function handleReset(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    var res = await sendPasswordReset(email);
    setBusy(false);
    if (res.error) setError(res.error);
    else setMode('sent');
  }

  if (mode === 'sent') {
    return (
      <AdminAuthCard heading="Check your email" icon={<IconMailForward size={22} />}
        intro={'If ' + email.trim() + ' belongs to an admin account, a link to choose a new password is on its way. It can take a few minutes, so check your spam folder too.'}>
        <button type="button" className="al-submit" onClick={function() { switchMode('signin'); }}>
          Back to sign in
        </button>
      </AdminAuthCard>
    );
  }

  if (mode === 'forgot') {
    return (
      <AdminAuthCard heading="Forgot your password?"
        intro="Type the email address you sign in with and we'll email you a link to choose a new password.">
        <form className="al-form" onSubmit={handleReset} noValidate>
          <div className="al-field">
            <label htmlFor="al-email">Email address</label>
            <input id="al-email" type="email" autoComplete="email" value={email}
              onChange={function(e) { setEmail(e.target.value); }} autoFocus />
          </div>
          <AuthMessage text={error} />
          <button type="submit" className="al-submit" disabled={busy}>
            {busy ? 'Sending…' : 'Email me a reset link'}
          </button>
        </form>
        <button type="button" className="al-link" onClick={function() { switchMode('signin'); }}>
          <IconArrowLeft size={14} /> Back to sign in
        </button>
      </AdminAuthCard>
    );
  }

  return (
    <AdminAuthCard heading="Admin sign in" intro="Sign in to edit your shop, products and orders.">
      <form className="al-form" onSubmit={handleSignIn} noValidate>
        <div className="al-field">
          <label htmlFor="al-email">Email address</label>
          <input id="al-email" type="email" autoComplete="username" value={email}
            onChange={function(e) { setEmail(e.target.value); }} autoFocus />
        </div>
        <div className="al-field">
          <label htmlFor="al-password">Password</label>
          <div className="al-pw">
            <input id="al-password" type={showPassword ? 'text' : 'password'} autoComplete="current-password"
              value={password} onChange={function(e) { setPassword(e.target.value); }} />
            <button type="button" className="al-pw-toggle"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              onClick={function() { setShowPassword(!showPassword); }}>
              {showPassword ? <IconEyeOff size={16} /> : <IconEye size={16} />}
            </button>
          </div>
        </div>
        <AuthMessage text={error} />
        <button type="submit" className="al-submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <button type="button" className="al-link" onClick={function() { switchMode('forgot'); }}>
        Forgot password?
      </button>
    </AdminAuthCard>
  );
}
